module.exports = __webpack_public_path__ + "img/account-vineyard_grey.a6c92809.svg";